<template>
    <proposal-form v-if="item" :item="item" />
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'
    import ProposalForm from './Form.vue';

    export default {
        components: {
            ProposalForm
        },

        created() {
            this.clearProjectServices()
            this.fetchProposalById(this.proposalId)
        },


        computed: {
            ...mapGetters(['proposalById']),

            proposalId() {
                return this.$route.params.slug
            },

            item() {
                return this.proposalById(parseInt(this.proposalId))
            }
        },

        methods: {
            ...mapActions(['fetchProposalById', 'clearProjectServices'])
        },

    }
</script>